import { VueExtension } from '../../utils/extensions/vue'
import ChartPie from './chartpie.jsx'
import './chartpie.scss'

VueExtension.WithInstall(ChartPie)

export default ChartPie